import type { CalendarEvent } from '@hooks'

export async function ensurePermission(): Promise<boolean> {
  return false
}

export async function getOrCreateCalendarId(_existingId: string | null): Promise<string> {
  return ''
}

export async function createDeviceEvent(
  _calendarId: string,
  _event: CalendarEvent,
): Promise<string> {
  return ''
}

export async function updateDeviceEvent(
  _deviceEventId: string,
  _event: CalendarEvent,
): Promise<void> {}

export async function deleteDeviceEvent(_deviceEventId: string): Promise<void> {}
